import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgSignUp() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="sign-up" /></AuthShell>;
}

export default AuthCoverBgSignUp;
